import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  background-color: red;
`;

export const Header = styled.div`
  grid-area: header;
  background-color: #4a6971;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  grid-area: container;
  background-color: #f5f5f5;
  overflow-y: scroll;
  min-height: 100%;
`;

export const BackContainer = styled.button`
  position: absolute;
  background: none;
  border: 0;
  left: 0;
  display: flex;
  align-items: center;
`;
